/**
 * 应用全局静态配置：平台名称、版本号、默认发件人等。
 * 如需更改平台名称或其它基础标识，统一在此修改一处即可。
 *
 * 同时通过 Vue.prototype.$appConfig 暴露给所有组件模板使用，避免到处硬编码文案。
 */
export const APP_TITLE = '途傲企业综合管理平台'

// 平台简称（用于侧边栏折叠/空间有限的场景，留空会自动取 APP_TITLE）
export const APP_SHORT_TITLE = '途傲综合管理平台'

// 版本号
export const APP_VERSION = '1.0.0'

// 默认邮箱发件人名称（仅作 placeholder/默认值参考，最终以系统设置页配置为准）
export const DEFAULT_SENDER_NAME = APP_TITLE

export default {
  APP_TITLE,
  APP_SHORT_TITLE,
  APP_VERSION,
  DEFAULT_SENDER_NAME
}
